export const socketScreens = {
  EDIT_DOCUMENT: 'editDocument',
  REDIRECT_TO_PREVIEW: 'redirectToPreview',
  CLOSE_TAB: 'closeTabConnection',
  PREVIEW: 'preview',
};

export const socketActions = {
  EDIT_CONNECT: 'editConnect',
  DEFAULT: 'default',
  STOP_EDIT: 'stopEdit',
  APPROVE_DENY: 'approveDeny',
  ACTIVE: 'active',
  REQUEST_ACCESS: 'requestAccess',
  SAVE_CONNECTION: 'saveConnection',
};

export const socketReadyStates = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

export const socketRequests = {
  APPROVED: 'approved',
  DENIED: 'denied',
  NO_CONNECTION: 'no connection',
};

export const socketMessages = {
  APPROVED: 'Request Approved. Redirecting in 3sec.',
  DENIED: 'Request Denied',
  NO_CONNECTION: 'User offline.',
};

export const socketUser = {
  VIEWER: 'viewer',
};

export const socketDocumentMessage = {
  EDITED: 'Document is being edited',
  NO_ACCESS: "You don't have access to edit",
  DEFAULT: '',
};

export const consumerComponents = {
  TASK_BOARD: 'taskBoard',
  APPLICATION_FORM: 'applicationForm',
  ACTIVITY_TAB: 'activityTab',
  EDITOR: 'editor',
  MY_DRIVE: 'myDrive',
  MAIN: 'main',
};
